import { REASONING_EFFORTS } from "@/constants/reasoningEffort";
import type { AIModel, ReasoningConfig } from "@/types";

/**
 * One reasoning effort per group-chat room (MHS-669): offer only the efforts every
 * configured bench model accepts. Models without a config (model-router) can't take
 * an effort anyway, so they don't veto the others.
 */
export function roomReasoningConfig(
  agents: readonly { uuid: string; modelId?: string }[],
  models: readonly AIModel[],
  inBench: (uuid: string) => boolean,
): ReasoningConfig | null {
  const lists = agents
    .filter((agent) => inBench(agent.uuid))
    .map((agent) => models.find((m) => m.id === agent.modelId)?.reasoningConfig?.supportedEfforts ?? [])
    .filter((efforts) => efforts.length > 0);
  if (lists.length === 0) return null;
  const shared = REASONING_EFFORTS.filter((effort) => lists.every((efforts) => efforts.includes(effort)));
  return shared.length > 0 ? { supportedEfforts: shared } : null;
}
